<template>
  <el-dialog
    class="course-offline"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="10vh"
    width="1000px"
    center
    @close="close"
  >
    <h2 class="title" slot="title"><icon-bell class="icon-bell" />课程下线通知</h2>
    <div class="content">
      <div class="desc">
        <div class="left">
          <p>
            亲爱的老师您好，为了给您提供更好的课程内容和更完善的教学功能，平台将于<time>2022年8月1日</time>对课程中心中部分普及课程的展示进行调整，调整可能会影响您的课包使用，给您带来的不便请您谅解，我们将尽快上线更优质的课程资源，敬请期待！
          </p>
          <p>
            如果您近期需要<strong>继续使用平台课程进行学习和授课</strong>，请您扫码加入我们的<strong>官方答疑服务群</strong>，群内会帮助您尽快解决。
          </p>
        </div>
        <div class="right">
          <img src="@/assets/image/qrcode_course_offline.jpg" />
          <div>
            微信扫一扫<br />
            官方答疑服务群
          </div>
        </div>
      </div>
      <h3 class="course-title">以下课程栏目即将下线</h3>
      <ul class="course-list">
        <li v-for="(el, i) in courses" :key="i">
          <img :src="el.img" :srcset="el.img2x" />
          <div>{{ el.name }}</div>
        </li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { reportEvent } from '@/utils/sensor'
import IconBell from '@/assets/svg/icon_bell.svg'
import teachers from './teachers.json'

export default {
  components: {
    IconBell
  },
  data() {
    return {
      visible: false,
      courses: [
        {
          name: '7天图形化编程训练营2期',
          img: require('@/assets/image/courseOffline/1.png'),
          img2x: require('@/assets/image/courseOffline/1@2x.png')
        },
        {
          name: '一线优秀教师公开课',
          img: require('@/assets/image/courseOffline/2.png'),
          img2x: require('@/assets/image/courseOffline/2@2x.png')
        },
        {
          name: '教师合作课*综合实践',
          img: require('@/assets/image/courseOffline/3.png'),
          img2x: require('@/assets/image/courseOffline/3@2x.png')
        },
        {
          name: '教师合作课*编程基础',
          img: require('@/assets/image/courseOffline/4.png'),
          img2x: require('@/assets/image/courseOffline/4@2x.png')
        },
        {
          name: '编程教育教学法',
          img: require('@/assets/image/courseOffline/5.png'),
          img2x: require('@/assets/image/courseOffline/5@2x.png')
        },
        {
          name: '编程猫护眼',
          img: require('@/assets/image/courseOffline/6.png'),
          img2x: require('@/assets/image/courseOffline/6@2x.png')
        },
        {
          name: '零基础编程精品课（体验）',
          img: require('@/assets/image/courseOffline/7.png'),
          img2x: require('@/assets/image/courseOffline/7@2x.png')
        },
        {
          name: '特色主题拓展课（体验）',
          img: require('@/assets/image/courseOffline/8.png'),
          img2x: require('@/assets/image/courseOffline/8@2x.png')
        }
      ]
    }
  },
  computed: {
    ...mapState(['user']),
    isContainTeacher() {
      return this.user ? teachers.includes(this.user.id) : false
    }
  },
  watch: {
    isContainTeacher(value) {
      if (value) {
        this.show()
      }
    }
  },
  methods: {
    show() {
      const showeds = JSON.parse(localStorage.getItem('visibleCourseOffline') || '[]')
      const showed = showeds.includes(this.user.id)
      if (!showed && this.checkDate()) {
        this.visible = true
        // 埋点上报
        reportEvent('Visit_Course_Offline_Popup')
      }
    },
    close() {
      const showeds = JSON.parse(localStorage.getItem('visibleCourseOffline') || '[]')
      const showed = showeds.includes(this.user.id)
      if (!showed) {
        showeds.push(this.user.id)
        localStorage.setItem('visibleCourseOffline', JSON.stringify(showeds))
      }
    },
    // 检查日期
    checkDate() {
      return moment().isBetween(moment('2022/07/25'), moment('2022/08/01'))
    }
  }
}
</script>

<style lang="scss" scoped>
.course-offline {
  ::v-deep {
    .el-dialog {
      height: 663px;
      background: image-set(
          url(../../assets/image/bg_course_offline.png) 1x,
          url(../../assets/image/bg_course_offline@2x.png) 2x
        )
        no-repeat 0 0 / 100% auto;
      box-shadow: none;
    }
    .el-dialog__header {
      padding: 48px 48px 16px;
    }
    .el-dialog__headerbtn {
      top: 25px;
      right: 20px;
      .el-dialog__close {
        color: #fff;
      }
    }
    .el-dialog__body {
      padding: 27px 43px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    height: 24px;
    color: #fff;
    font-size: 24px;
    font-weight: 400;
    .icon-bell {
      margin-right: 5px;
      width: 24px;
      height: 24px;
    }
  }
  .content {
    padding: 0 38px;
    color: #333;
    line-height: 24px;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    .left {
      width: 582px;
      time {
        color: #fc3b3b;
      }
      strong {
        color: #00c4aa;
        font-weight: 400;
      }
      p + p {
        margin-top: 12px;
      }
    }
    .right {
      display: flex;
      margin-top: 6px;
      padding: 5px;
      width: 250px;
      height: 120px;
      border: 1px solid #bce9dd;
      border-radius: 4px;
      img {
        width: 108px;
        height: 108px;
      }
      div {
        display: flex;
        align-items: center;
        padding-left: 15px;
      }
    }
  }
  .course-title {
    margin: 15px 0 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .course-list {
    display: flex;
    flex-wrap: wrap;
    li {
      margin: 0 12px 12px 0;
      padding: 7px;
      width: 158px;
      height: 146px;
      border: 1px solid #e9e9e9;
      border-radius: 3px;
      &:nth-child(5) {
        margin-right: 0;
      }
      img {
        display: block;
        width: 100%;
        height: 109px;
      }
      div {
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }
}
</style>
